"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _default = function _default(theme) {
  return {
    BaseAlign: {
      textAlign: 'left',
      minHeight: 32
    },
    KindLite: {
      '&.kind-lite': {
        background: theme['$dropdown-lite-background']
      },
      '&:active, &.active': {
        '&.kind-lite': {
          background: theme['$dropdown-lite-active']
        }
      }
    },
    Menu: {
      minWidth: 180,
      maxHeight: 250,
      overflowY: 'auto'
    },
    Title: {
      '& > *': {
        padding: 0
      }
    },
    tetherElement: {
      zIndex: theme['$z-index-dropdown']
    }
  };
};

exports["default"] = _default;
//# sourceMappingURL=style.js.map